/**
 * 网络请求
 */
import axios from "axios"; // 推荐接口请求
import './httpInterceptor'; // 接口拦截器

  // ? 参数封装
  function searchParam(params) {
    const searchParam = new FormData();
    for (const key in params) {
      if (Array.isArray(params[key])) searchParam.append(key, JSON.stringify(params[key]));
      else searchParam.append(key, params[key] != null ? params[key] : "");
    }
    return searchParam;
  };

  // ? 推荐接口-get请求
  function axiosGetResponse(url, param = {}, headers = {}) {
    if (!url) { console.warn("url为空") }
    return axios.get(url, {
      params: param,
      headers: headers
    }).then((res) => {
      return res.data;
    }).catch((error) => {
      return error;
    });
  };

  // ? 推荐接口-post请求
  function axiosPostResponse(url, param = {}, withCredentials = true) {
    if (!url) { console.warn("url为空") }
    return axios({
      method: "post",
      url: url,
      withCredentials: withCredentials,
      data: param
    }).then((res) => {
      if (res) return res.data;
    }).catch((error) => {
      return error;
    });
  };

  // ? 推荐接口-post请求表单格式
  function axiosPostFormResponse(url, param = {}) {
    if (!url) { console.warn("url为空") }
    return axios({
      method: "post",
      url: url,
      withCredentials: true,
      data: this.searchParam(param)
    }).then((res) => {
      if (res) return res.data;
    }).catch((error) => {
      return error;
    });
  };

  // ? 推荐接口-put请求
  function axiosPutResponse(url, param = {}) {
    if (!url) { console.warn("url为空") }
    return axios({
      method: "put",
      url: url,
      withCredentials: true,
      data: param
    }).then((res) => {
      if (res) return res.data;
    }).catch((error) => {
      return error;
    });
  };

  // ? 推荐接口-delete请求
  function axiosDeleteResponse(url, param = {}) {
    if (!url) { console.warn("url为空") }
    return axios.delete(url, {
      params: param
    }).then((res) => {
      if (res) return res.data;
    }).catch((error) => {
      return error;
    });
  };

  //? delete 请求 body格式
  function axiosDeleteResponse2(url, param = {}) {
    if (!url) { console.warn("url为空") }
    return axios({
      method: "delete",
      url: url,
      headers: { 
        'Content-Type': 'application/json'
      },
      data : param
    }).then((res) => {
      return res.data;
    }).catch((error) => {
      return error;
    });
  };

  // ? 推荐接口-并发
  function axiosAllResponse(request) {
    return axios.all(request).then(axios.spread((...res) => {
      return res;
    }));
  };

  // ? 推荐接口-文件下载
  function axiosFileDowload(url, param = {}) {
    if (!url) { console.warn("url为空") }
    return axios({
      method: "post",
      url: url,
      withCredentials: true,
      data: param,
      responseType: "blob"
    }).then((res) => {
      const href = window.URL.createObjectURL(new Blob([res.data]));
      const downloadElement = document.createElement("a");
      downloadElement.style.display = "none";
      downloadElement.href = href;
      downloadElement.download = decodeURI(res.headers["filename"]);
      document.body.appendChild(downloadElement);
      downloadElement.click(); // 点击下载
      document.body.removeChild(downloadElement); // 下载完成移除元素
      window.URL.revokeObjectURL(href); // 释放blob对象
    });
  };

  // ? 推荐接口-文件上传
  function cancel() { };
  function axiosUploadResponse(url, param = {}) {
    if (!url) { console.warn("url为空") }
    return axios({
      method: "post",
      url: url,
      onUploadProgress: (progressEvent) => {
        let a = progressEvent.loaded * 100 / progressEvent.total;
        if (a > 100) a = 100;
      },
      data: this.searchParam(param),
      cancelToken: new axios.CancelToken((c) => {
        this.cancel = c;
      })
    }).then((res) => {
      return res.data;
    }).catch((error) => {
      return error;
    });
  };

  // ? 推荐接口-中断文件上传
  function axiosCancel() {
    this.cancel();
  };

export default {
  searchParam,
  install(Vue) {
    Vue.prototype.$axiosGet = axiosGetResponse; // 推荐接口-get请求
    Vue.prototype.$axiosPost = axiosPostResponse; // 推荐接口-post请求
    Vue.prototype.$axiosPostForm = axiosPostFormResponse; // 推荐接口-post请求表单格式
    Vue.prototype.$axiosPut = axiosPutResponse; // 推荐接口-put请求
    Vue.prototype.$axiosDelete = axiosDeleteResponse; // 推荐接口-delete请求
    Vue.prototype.$axiosBodyDelete = axiosDeleteResponse2; // delete 请求 body格式
    Vue.prototype.$axiosAll = axiosAllResponse; // 推荐接口-并发
    Vue.prototype.$axiosDowload = axiosFileDowload; // 推荐接口-文件下载
    Vue.prototype.$axiosUpload = axiosUploadResponse; // 推荐接口-文件上传
    Vue.prototype.$axiosCancel = axiosCancel; // 推荐接口-中断文件上传
  }
};
